"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialListRequest = void 0;
var FinancialListRequest = /** @class */ (function () {
    function FinancialListRequest() {
    }
    return FinancialListRequest;
}());
exports.FinancialListRequest = FinancialListRequest;
;
//# sourceMappingURL=financialList.request.js.map